import type { ActionsOfCreators, FeatureHandler } from '../helpers';

import { newJob } from './newJob';

export const inputActions = [newJob];

export type InputActions = ActionsOfCreators<typeof inputActions>;

export type InputHandler<T extends InputActions> = FeatureHandler<
  T,
  InputActions
>;
